import Fetcher from 'od-modules/utils/fetcher';

const URL = 'getresidentzonesforitinerary';
const FORMATTED_URL = Odigeo.Settings.getProperty('coreUrlFormatter')(URL);

const Model = Backbone.Model.extend({
    connect: true,
    silentChange: false,
    selectors: ['residentDiscountApplied', 'numPassengers', 'tripIatas', 'tripType', 'paxTypesNumber', 'resultsSelection'],
    getResidentZones() {
        const tripIatas = this.get('tripIatas');
        const tripType = this.get('tripType');
        const {numCHILD, numINFANT} = this.get('paxTypesNumber');
        const shouldCheckPaxType = Odigeo.AB.isShouldCheckPaxType || (numCHILD === 0 && numINFANT === 0);
        if (tripIatas && tripType && shouldCheckPaxType) {
            const isMultidestination = this.get('tripType') === 'MULTIPLE_DESTINATIONS';
            const {flight0: {departure, arrival} = {}} = this.get('tripIatas');
            !isMultidestination && Fetcher.get(`${FORMATTED_URL}?departureIata=${departure}&arrivalIata=${arrival}`)
                .json()
                .then(this.saveResidentZones.bind(this));
        }
    },
    saveResidentZones(residentZones) {
        const zonesString = Array.isArray(residentZones) ? residentZones.join(' o ') : residentZones;
        this.set({
            residentZones: Odigeo.Utils.stringToProperCase(zonesString),
        });
    },
});

export default Model;
